module.exports = __webpack_public_path__ + "img/Guillame Ballet.a007048a.jpg";